export const addComma = (number: number): string => {
  return number.toLocaleString()
}

export const addHyphenToPhoneNumber = (number: string): string => {
  return number.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
}

export function formatNumberUpTo9999(number: number): string {
  return number > 9999 ? '9,999+' : number.toLocaleString()
}
